import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import styles from "./Pagination.module.css"; // ✅ import correct CSS

const Pagination = ({ totalPages, currentPage, onPageChange }) => {
  if (totalPages <1) return null;

  const getPageNumbers = () => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
    if (currentPage <= 3) return [1, 2, 3, 4, "...", totalPages];
    if (currentPage >= totalPages - 2)
      return [1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    return [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
  };

  const handlePrev = () => currentPage > 1 && onPageChange(currentPage - 1);
  const handleNext = () => currentPage < totalPages && onPageChange(currentPage + 1);

  return (
    <div className={styles.paginationWrapper}>
    <div className={styles.pagination}>
      <button onClick={handlePrev} disabled={currentPage === 1} className={styles.pageButton}>
        <ChevronLeft />
      </button>

      {getPageNumbers().map((page, idx) =>
        page === "..." ? (
          <span key={idx} className={styles.pageNumber}>…</span>
        ) : (
          <button
            key={idx}
            onClick={() => onPageChange(page)}
            className={`${styles.pageNumber} ${currentPage === page ? styles.activePage : ""}`}
          >
            {page}
          </button>
        )
      )}

      <button onClick={handleNext} disabled={currentPage === totalPages} className={styles.pageButton}>
        <ChevronRight />
      </button>
    </div>
    </div>
  );
};

export default Pagination;
